const KEY_PREFIX = 'oc_line_login_at_v1:'
export const LIFF_LOGIN_TTL_MS = 48 * 60 * 60 * 1000

function key(botId: string) {
  return `${KEY_PREFIX}${botId === '2' ? '2' : '1'}`
}

export function hasFreshLiffLogin(botId: string): boolean {
  try {
    const at = Number(localStorage.getItem(key(botId)) || 0)
    return Number.isFinite(at) && at > 0 && Date.now() - at < LIFF_LOGIN_TTL_MS
  } catch {
    return false
  }
}

export function markLiffLogin(botId: string): void {
  try {
    localStorage.setItem(key(botId), String(Date.now()))
  } catch {
    /* private mode */
  }
}

export function clearLiffLogin(botId: string): void {
  try {
    localStorage.removeItem(key(botId))
  } catch {
    /* private mode */
  }
}

/** ไม่รู้ว่าลูกค้าใช้บอทไหน (ไม่มี botId ใน URL) → ตรวจทั้งสองบอท */
export function hasAnyFreshLiffLogin(botId = ''): boolean {
  if (botId === '1' || botId === '2') return hasFreshLiffLogin(botId)
  return hasFreshLiffLogin('1') || hasFreshLiffLogin('2')
}
